/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* istanbul ignore file */
const apiUrl = { general: '/api/', case: '/api/Case' }
const apiMethod = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE',
  patch: 'PATCH',
}
const ManualReviewAPIEndpoints = {
  getAllEventStatus: {
    url: `${apiUrl?.general}Observation/GetAllEventStatus`,
    method: apiMethod?.post,
    methodname: 'getAllEventStatus',
  },
  getFuzzyVrmData: {
    url: `${apiUrl?.general}Observation/observationId/__observationId__/FuzzyVrm/__fuzzyVrm__`,
    method: apiMethod?.post,
    methodname: 'getFuzzyVrmData',
  },
  getObservationDetailsById: {
    url: `${apiUrl?.general}Observation/__observationId__`,
    method: apiMethod?.get,
    methodname: 'getObservationDetailsById',
  },
  updateHoldReview: {
    url: `${apiUrl?.general}Observation/observationId/__observationId__/UpdateHoldReview`,
    method: apiMethod?.put,
    methodname: 'updateHoldReview',
  },
  updateVRM: {
    url: `${apiUrl?.general}Observation/observationId/__observationId__/VRM/__vrmValue__/UpdateVRM`,
    method: apiMethod?.put,
    methodname: 'updateVRM',
  },
  getVehicleColorList: {
    url: `${apiUrl?.general}Vehicle/Color`,
    method: apiMethod?.get,
    methodname: 'getVehicleColorList',
  },
  getVehicleMakeList: {
    url: `${apiUrl?.general}Vehicle/Make`,
    method: apiMethod?.get,
    methodname: 'getVehicleMakeList',
  },
  getVehicleTypeList: {
    url: `${apiUrl?.general}Observation/VehicleTypes`,
    method: apiMethod?.get,
    methodname: 'getVehicleTypeList',
  },
  getDiscardReasons: {
    url: `${apiUrl?.general}DiscardReason/ContractId/__contractId__`,
    method: apiMethod?.get,
    methodname: 'getDiscardReasons',
  },
  saveDiscard: {
    url: `${apiUrl?.general}Discard`,
    method: apiMethod?.put,
    methodname: 'saveDiscard',
  },
  saveProceed: {
    url: `${apiUrl?.general}Observation/observationId/__observationId__/Contract/__contractId__/UpdateProceed`,
    method: apiMethod?.put,
    methodname: 'saveProceed',
  },
  getContraventionCodesByLocation: {
    url: `${apiUrl?.general}Contract/__contractId__/Location/__locationId__/ContraventionCodes`,
    method: apiMethod?.get,
    methodname: 'getContraventionCodesByLocation',
  },
  updateContraventionCode: {
    url: `${apiUrl?.general}Observation/__observationId__/contraventionId/__contraventionId__/contraventionCode/__contraventionCode__/UpdateContravention`,
    method: apiMethod?.put,
    methodname: 'updateContraventionCode',
  },
  getContraventionLocation: {
    url: `${apiUrl?.general}ContraventionCode/Contract/__contractId__/Contravention/__contraventionId__/Location/__locationId__/ContraventionLocation`,
    method: apiMethod?.get,
    methodname: 'getContraventionLocation',
  },
  getMovementsList: {
    url: `${apiUrl?.general}Observation/Movements`,
    method: apiMethod?.post,
    methodname: 'getMovementsList',
  },
}

export default ManualReviewAPIEndpoints
